// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage, intlShape } from 'react-intl';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import style from './StepTracker.scss';

import type { Step } from '../../duck';

type Props = {
  +step: Step;
  /*+changeStateToProducts: (url?: string) => void;
  +changeStateToDelivery: () => void;
  +changeStateToSummary: () => void;*/
  // +handleClickTrackingStep: (stepLabel: string) => void;
};

const stepsLabel: string[] = [
  'product',
  'quote',
  'checkout',
];

/*const stepsArrange: string[] = [
  'products',
  'delivery',
  'delivery-info',
  'summary',
];*/

/*const titlesArray = [
  'newOrder.tracking.step.one',
  'newOrder.tracking.step.two',
  'newOrder.tracking.step.three',
];

const titlesDescriptionArray = [
  'newOrder.tracking.step.one.description',
  'newOrder.tracking.step.two.description',
  'newOrder.tracking.step.three.description',
];*/

const stepLabelsIntl = [
  'newOrder.tracking.step.product',
  'newOrder.tracking.step.quote',
  'newOrder.tracking.step.checkout',
];

export default class StepTracker extends Component<Props, void> {
  calculateProgress = (step: string): number => {
    switch (step) {
      case 'product':
        return 0;
      case 'quote':
        return 50;
      case 'checkout':
        return 100;
      default:
        return 0;
    }
  };

  render() {
    const { step, /*handleClickTrackingStep*/ } = this.props;
    const progress = this.calculateProgress(step);
    const stepIndex = stepsLabel.indexOf(step);

    const steps = stepsLabel.map((s: string, n: number) => {
      return (
        <li key={n}
          /*onClick={() => handleClickTrackingStep(s)}*/
            className={classNames(style.state,
              { [style.lightBlue]: n <= stepIndex })}>
          <FormattedMessage id={stepLabelsIntl[n]}>{
            txt => <p className={style.stepLabel}>{txt}</p>
          }</FormattedMessage>
          <span className={classNames(style.stepNumberLabel, { [style.selected]: n <= stepIndex })}>{n + 1}</span>
        </li>);
    });
    const trackerContent = (
      <section key="stepTrackerWrap" className={style.stepTrackerWrap}>
        <FormattedMessage id={stepLabelsIntl[stepIndex]}>{
          txt => <p className={style.stepLabel}>{txt}</p>
        }</FormattedMessage>
        <ul className={style.stepTrackerContent}>
          {steps}
        </ul>
        <div className={style.reel}>
          <div style={{ width: `${progress}%` }}
               className={style.progress}/>
        </div>
      </section>
    );

    return (<Fragment>
      {trackerContent}
    </Fragment>);
  }
}

StepTracker.propTypes = {
  step: PropTypes.string.isRequired,
  // handleClickTrackingStep: PropTypes.func.isRequired,
};

StepTracker.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/components/StepTracker/StepTracker.jsx